module.exports = __webpack_public_path__ + "img/group_introduce.9580af0f.png";